import { FC } from 'react';
import { SvgIcon } from '../SvgIcons/svgIcons';
import { theme } from '../theme';
import styled from 'styled-components';
import { IconKey } from '../SvgIcons/svgIconsParams';

const MenuItem = styled.button`
  display: flex;
  padding: ${({ theme }) => theme.designToken.spacing2} ${({ theme }) => theme.designToken.spacing3};
  align-items: center;
  border: none;
  cursor: pointer;
  background: ${({ theme }) => theme.designToken.baseWhite};
  width: 100%;
  :hover {
    background: ${({ theme }) => theme.designToken.primary50};
  }
`;

const Title = styled.div`
  color: ${({ theme }) => theme.designToken.neutral900};
  margin-left: ${({ theme }) => theme.designToken.spacing2};
  word-break: keep-all;
`;

export interface IProps extends IntrinsicProps {
  icon?: IconKey;
  onClick?: () => void;
}

export const ActionMenuItem: FC<IProps> = ({ onClick, children, icon, ...rest }) => (
  <MenuItem onClick={onClick} {...rest}>
    <SvgIcon name={icon} size="24" color={theme.designToken.neutral700} />
    <Title>{children}</Title>
  </MenuItem>
);
